﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadDrawingSheetField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadDrawingSheetField, eOutputFieldType.cadDrawingSheet)
export class CadDrawingSheetField extends OutputField implements ICadDrawingSheetField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public scaleNumerator: number;
    public scaleDenominator: number;
    public useCustomScale: boolean;
    public deleted: boolean;
}
